/**
 * VAT Payer Type
 *
 * A party's VAT registration status; null on a party means unknown.
 */
export const VatPayerType = {
  PAYER: 'PAYER', // Plátce DPH
  NON_PAYER: 'NON_PAYER', // Neplátce DPH
  IDENTIFIED_PERSON: 'IDENTIFIED_PERSON' // Identifikovaná osoba
} as const;

export type VatPayerType = (typeof VatPayerType)[keyof typeof VatPayerType];
